import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '../components/layout/layout.component';
import { StaffComponent } from './staff/staff.component';
import { SchoolInfoComponent } from './school-info/school-info.component';
import { GradesClassesComponent } from './grades-classes/grades-classes.component';
import { GatesComponent } from './gates/gates.component';
import { DismissalFlowComponent } from './dismissal-flow/dismissal-flow.component';
import { NamesSoundsComponent } from './names-sounds/names-sounds.component';
import { DismissalTimeComponent } from './dismissal-time/dismissal-time.component';
import { SectionsComponent } from './sections/sections.component';
import { AddSectionComponent } from './add-section/add-section.component';

const routes: Routes = [
    {
        path: '', component: LayoutComponent,
        children: [
            {
                path: 'school-info',
                component: SchoolInfoComponent
            },
            {
                path: 'staff',
                component: StaffComponent
            },
            {
                path: 'grades-classes',
                component: GradesClassesComponent
            },
            {
                path: 'gates',
                component: GatesComponent
            },
            {
                path: 'dismissal-flow',
                component: DismissalFlowComponent
            },
            {
                path: 'names-sounds',
                component: NamesSoundsComponent
            },
            {
                path: 'dismissal-time',
                component: DismissalTimeComponent
            },
            {
                path: 'sections',
                component: SectionsComponent
            },
            {
                path: 'sections/:mode/:id',
                component: AddSectionComponent
            },
            // {
            //     path: 'tracking',
            //     component: BusTrackingComponent
            // },
            {
                path: '',
                redirectTo: '/school-management/school-info',
                pathMatch: 'full'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class SchoolManagementRoutingModule { }